// extracted by mini-css-extract-plugin
export default {"list":"rbz1g","byTwo":"pg1wW","list-item":"LzD8d"};